<template>
  <div class="modal-content">
    <div class="modal-header">
      <div>
        <div class="well well-sm well-partial" v-if="isPartialReservation">
          <i class="fa fa-fw fa-1x fa-lock"></i> {{_('Order') }}: {{ orderId }}
          <i style="margin-left: 10px;" class="fa fa-fw fa-1x fa-calendar"></i> {{ reservationText }}: {{ reservationId }}
          <span style="display: inline-block; padding-left: 10px">
            <button class="btn btn-xs btn-default" style="line-height: 10px" v-on:click="selectPreviousPartialReservation"><i class="fa fa-fw fa-arrow-left"></i></button>
            {{ partialReservationStatusText }}
            <button class="btn btn-xs btn-default" style="line-height: 10px" v-on:click="selectNextPartialReservation"><i class="fa fa-fw fa-arrow-right"></i></button>
          </span>
        </div>
        <div class="well well-sm" v-else-if="isInvoicedOrder">
          <i class="fa fa-fw fa-1x fa-lock"></i> {{_('Order') }}: {{ orderId }}
          <i style="margin-left: 10px;" class="fa fa-fw fa-1x fa-calendar"></i> {{ reservationText }}: {{ reservationId }}
        </div>
        <div class="well well-sm well-warning" v-else-if="isConfirmedOrder">
          <i class="fa fa-fw fa-1x fa-unlock"></i> {{_('Confirmed order') }}: {{ orderId }}
          <i style="margin-left: 10px;" class="fa fa-fw fa-1x fa-calendar"></i> {{ reservationText }}: {{ reservationId }}
        </div>
        <div class="well well-sm well-info" v-else-if="isOpenOrder">
          <i class="fa fa-fw fa-1x fa-unlock"></i> {{_('Open order') }}: {{ orderId }}
          <i style="margin-left: 10px;" class="fa fa-fw fa-1x fa-calendar"></i> {{ reservationText }}: {{ reservationId }}
        </div>
        <div class="well well-sm" v-else-if="isReservation">
          <i class="fa fa-fw fa-1x fa-unlock"></i> {{ reservationText }}: {{ reservationId }}
        </div>
        <div class="well well-sm" style="clear: both" v-if="allResources.length > 0">
          <div v-for="resource in allResources">
            <i class="fa fa-fw fa-1x fa-cube"></i> {{ resource.name }}
          </div>
        </div>
      </div>
      <h3 class="modal-title">{{ title }}</h3>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div id="checkInOut" v-if="reservation">
            <button v-if="!reservation.checkin_ts" type="button" class="btn btn-xs btn-success" v-on:click="checkIn(reservation)"><i class="fa fa-fw fa-sign-in"></i> {{ _('Check in') }}</button>
            <button v-else type="button" class="btn btn-xs btn-default" v-on:click="cancelCheckIn(reservation)"><i class="fa fa-fw fa-check"></i> {{ _('Checked in') }} {{ $filters.timestampToDate(reservation.checkin_ts) }} {{ _('at') }} {{ $filters.timestampToTime(reservation.checkin_ts) }}</button>
            <button v-if="!reservation.checkout_ts" type="button" class="btn btn-xs btn-info" v-on:click="checkOut(reservation)" :disabled="reservation.checkin_ts ? false : 'disabled'"><i class="fa fa-fw fa-sign-out"></i> {{ _('Check out') }}</button>
            <button v-else type="button" class="btn btn-xs btn-default" v-on:click="cancelCheckOut(reservation)"><i class="fa fa-fw fa-check"></i> {{ _('Checked out') }} {{ $filters.timestampToDate(reservation.checkout_ts) }} {{ _('at') }} {{ $filters.timestampToTime(reservation.checkout_ts) }}</button>
          </div>
          <div class="form-group">
            <h5 id="eventContact">{{ phone }}{{ contactSeparator }}<a v-if="email" :href="'mailto:' + email">{{ email }}</a></h5>
            <h4 id="eventDates">{{ dateRange }}</h4>
            <div class="reservation-preview-pickups" v-if="pickupPlaces.length">
              <div v-for="place in pickupPlaces" :key="place.role" class="reservation-preview-pickup">
                <i class="fa fa-fw" :class="place.role === 'dropoff' ? 'fa-flag-checkered' : 'fa-map-marker'"></i>
                <strong>{{ place.label }}:</strong>
                <template v-if="place.time"> {{ place.time }}</template>
                {{ place.name }}<small v-if="place.address" class="text-muted">, {{ place.address }}</small>
                <a v-if="place.mapUrl" :href="place.mapUrl" target="_blank" rel="noopener" :title="_('Show on map')"><i class="fa fa-fw fa-external-link"></i></a>
              </div>
            </div>
            <hr>
            <div id="eventOrder" v-if="order">
              <p><strong>{{ _('Order') }} {{ orderId }}:</strong></p>
              <table class="order_popup_table">
                <tbody>
                  <tr v-for="item in order.ownItem">
                    <td class="order_popup_name" v-html="item.product_name + itemSeparator(item) + getReservationDesc(item)"></td>
                    <td class="order_popup_count">{{ item.count }} {{ _('pcs') }}</td>
                    <td class="order_popup_price">{{ itemPrice(item) }}</td>
                  </tr>
                  <tr class="totals">
                    <td class="order_popup_name"><strong>{{ _('Total') }}</strong></td>
                    <td class="order_popup_count">&nbsp;</td>
                    <td class="order_popup_price"><strong>{{ orderTotal }}</strong></td>
                  </tr>
                </tbody>
              </table>
              <template v-if="order.more">
                <hr />
                <h5>{{ _('Additional info') }}</h5>
                <p>{{ order.more }}</p>
              </template>
              <div class="form-group" v-if="formresponses.length">
                <h5>{{ _('Forms') }}</h5>
                <div v-for="formresponse in formresponses">
                  <div v-for="(answer, question) in formresponse" :key="question" class="formresponse-question">
                    <strong>{{ question }}:</strong> <span>{{ answer }}</span>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="order">
                <h5>{{ _('Notes') }}</h5>
                <textarea class="form-control" rows="4" v-model="order.notes"></textarea>
              </div>
            </div>
            <div class="reservation-preview-end" v-if="order || channelLogo || channelText">
              <img v-if="channelLogo" class="reservation-preview-channel" :src="channelLogo" :alt="channelName" :title="channelName">
              <strong v-else-if="channelText" class="reservation-preview-channel reservation-preview-channel-text">{{ channelText }}</strong>
              <button v-if="order" class="btn btn-xs btn-success" v-on:click="saveNotes"><i class="fa fa-fw fa-save"></i> {{ _('Save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-row space-between">
        <button v-if="order" class="btn btn-info" v-on:click="displayOrder"><i class="fa fa-fw fa-shopping-cart"></i> {{ _('Display order') }}</button>
        <div class="button-col">
          <button class="btn btn-success" v-on:click="editReservation"><i class="fa fa-fw fa-pencil"></i><span class="hidden-sm hidden-md hidden-lg"> {{ _('Edit') }}</span><span class="hidden-xs"> {{ _('Edit reservation') }}</span></button>
          <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

const CHANNEL_LOGOS = {
  booking: 'booking.svg',
  bokun: 'bokun.png',
  trip: 'trip.svg',
  airbnb: 'airbnb.svg',
  expedia: 'expedia.svg',
  agoda: 'agoda.svg',
  hotels: 'hotels.svg',
  nettimokki: 'nettimokki.svg',
  johku: 'johku.svg',
  app: 'app.svg'
}
// Channels without a logo asset are shown as text
const CHANNEL_TEXTS = {
  gyg: 'GetYourGuide'
}

export default {
  props: ['reservation', 'order', 'customTitle', 'channel', 'channelName', 'pickup', 'dropoff'],
  computed: {
    ...mapGetters(['timezone', 'dateFormat', 'timeFormat']),
    // Activity pricing: pick-up and drop-off of the schedule row ({name, time, address, lat, lng})
    pickupPlaces () {
      const places = []
      const add = (place, role, label) => {
        if (!place || !place.name) {
          return
        }
        const time = place.time ? DateTime.fromFormat(String(place.time), 'H:mm') : null
        places.push({
          role,
          label,
          name: place.name,
          time: time && time.isValid ? time.toFormat(this.timeFormat) : (place.time || ''),
          address: place.address || '',
          mapUrl: place.lat && place.lng ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(place.lat + ',' + place.lng) : null
        })
      }
      add(this.pickup, 'pickup', this._('Pick-up'))
      add(this.dropoff, 'dropoff', this._('Drop-off'))
      return places
    },
    channelLogo () {
      return CHANNEL_LOGOS[this.channel] ? '/img/channels/logos/' + CHANNEL_LOGOS[this.channel] : null
    },
    channelText () {
      return CHANNEL_TEXTS[this.channel] || null
    },
    allResources () {
      const allResources = []
      if (this.order && this.order.ownItem) {
        this.order.ownItem.forEach(item => {
          if (item.ownReservation && Array.isArray(item.ownReservation)) {
            const reservation = item.ownReservation.find(res => res && Number(res.id) === Number(this.reservation.id))
            if (reservation && reservation.sharedResource && Array.isArray(reservation.sharedResource)) {
              reservation.sharedResource.forEach(resource => {
                if (resource && resource.id && !allResources.find(r => r.id === resource.id)) {
                  allResources.push(resource)
                }
              })
            }
          }
        })
      }
      return allResources
    },
    title () {
      return this.orderTitle ? this.orderTitle : (this.reservationTitle ? this.reservationTitle : this.customTitle)
    },
    orderTitle () {
      return this.order ? (this.order.name ? this.order.name : '') + (this.order.company ? ', ' + this.order.company : '') : false
    },
    reservationTitle () {
      return this.reservation ? (this.reservation.client_name ? this.reservation.client_name : '') + (this.reservation.client_company ? ', ' + this.reservation.client_company : '') : false
    },
    reservationText () {
      if (this.reservation && Number(this.reservation.partial)) {
        return this._('Partial reservation')
      }
      return this._('Reservation')
    },
    partialReservationStatusText () {
      return this.isPartialReservation ? '(' + this.partialReservationIndex + ' / ' + this.partialReservationCount + ')' : ''
    },
    partialReservationIndex () {
      if (this.order && this.order.ownItem) {
        let partialIndex = 0
        this.order.ownItem.forEach(item => {
          if (item.ownReservation && Array.isArray(item.ownReservation)) {
            partialIndex = item.ownReservation.findIndex(res => res && res.item_id === this.reservation.item_id && Number(res.id) === Number(this.reservation.id))
          }
        })
        return partialIndex + 1
      }
      return 1
    },
    partialReservationCount () {
      if (this.order && this.order.ownItem) {
        let partialCount = 0
        this.order.ownItem.forEach(item => {
          if (item.ownReservation && Array.isArray(item.ownReservation)) {
            item.ownReservation.forEach(res => {
              if (res && res.item_id === this.reservation.item_id && Number(res.partial) === 1) {
                partialCount += 1
              }
            })
          }
        })
        return partialCount
      }
      return 0
    },
    phone () {
      return this.reservation && this.reservation.client_phone ? this._('tel.') + ' ' + this.reservation.client_phone : ''
    },
    email () {
      return this.reservation ? this.reservation.client_email : ''
    },
    startDate () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).toFormat(this.dateFormat) : ''
    },
    startTime () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).toFormat(this.timeFormat) : ''
    },
    endDate () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).toFormat(this.dateFormat) : ''
    },
    endTime () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).toFormat(this.timeFormat) : ''
    },
    dateRange () {
      if (!this.reservation || !this.startDate || !this.endDate) {
        return ''
      }
      return this.startDate + ' ' + this._('at') + ' ' + this.startTime + ' - ' + (this.endDate != this.startDate ? this.endDate + ' ' + this._('at') + ' ' : '') + this.endTime
    },
    contactSeparator () {
      return this.phone && this.email ? ', ' : ''
    },
    orderId () {
      return this.order ? this.order.id : ''
    },
    orderTotal () {
      if (!this.order) {
        return ''
      }
      let curr = this.$filters.currency
      let currency = this.order.ownItem[0].currency
      return curr(this.order.totalWithDelivery, currency)
    },
    reservationId () {
      return this.reservation ? this.reservation.id : null
    },
    isOrder () {
      return this.orderId ? true : false
    },
    isOpenOrder () {
      if (this.isOrder) {
        if (this.order.payment === 'open') {
          return true
        }
      }
      return false
    },
    isConfirmedOrder () {
      if (this.isOrder) {
        if (parseInt(this.order.confirmed) === 1) {
          return true
        }
      }
      return false
    },
    isInvoicedOrder () {
      if (this.isOrder) {
        for (let i = 0; i < this.order.ownItem.length; i++) {
          if (parseInt(this.order.ownItem[i].bill_id)) {
            return true
          }
        }
      }
      return false
    },
    isReservation () {
      if (!this.isOrder && this.reservation) {
        return true
      }
      return false
    },
    isPartialReservation () {
      return this.partialReservationCount > 0
    },
    formresponses () {
      if (!this.order || !this.order.ownItem || !this.order.ownItem.length) {
        return []
      }
      return this.order.ownItem.filter(item => item.formresponse).map(item => typeof item.formresponse === 'string' ? JSON.parse(item.formresponse) : item.formresponse)
    }
  },
  methods: {
    saveNotes () {
      this.$emit('saveNotes', this.order)
    },
    selectPreviousPartialReservation () {
      this.$emit('selectPreviousPartialReservation', { order: this.order, reservation: this.reservation, text: this.title })
    },
    selectNextPartialReservation () {
      this.$emit('selectNextPartialReservation', { order: this.order, reservation: this.reservation, text: this.title })
    },
    checkIn(item) {
      this.$emit('checkin', item)
    },
    checkOut(item) {
      this.$emit('checkout', item)
    },
    cancelCheckIn(item) {
      this.$emit('cancelCheckin', item)
    },
    cancelCheckOut(item) {
      this.$emit('cancelCheckout', item)
    },
    getReservationDesc (item) {
      let res = false
      if (item && item.ownReservation) {
        if (item.ownReservation.length > 1) {
          res = item.ownReservation.find(res => res && res.item_id === this.reservation.item_id && Number(res.id) === Number(this.reservation.id))
        } else {
          res = item.ownReservation[0]
        }
      }
      if (res) {
        if (res.start_ts != item.start_ts || res.end_ts != item.end_ts) {
          return DateTime.fromSeconds(Number(res.start_ts), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' +  this._('at') + ' ' + DateTime.fromSeconds(Number(res.start_ts), { zone: this.timezone }).toFormat(this.timeFormat) + ' - ' + 
                 DateTime.fromSeconds(Number(res.end_ts), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' +  this._('at') + ' ' + DateTime.fromSeconds(Number(res.end_ts), { zone: this.timezone }).toFormat(this.timeFormat) + 
                 '<br /><small style="color: #666; font-weight: normal">' +
                 '(' + this._('was') + ': ' + item.reservation_desc + ')' +
                 '</small>'
        }
      }
      return item.reservation_desc ? item.reservation_desc : ''
    },
    hideModal () {
      this.$emit('close')
    },
    displayOrder () {
      this.$emit('displayOrder', this.orderId)
    },
    editReservation () {
      this.$emit('editReservation', this.reservationId, this.orderId)
    },
    itemSeparator (item) {
      return item.product_name && item.reservation_desc ? ', ' : ''
    },
    itemPrice (item) {
      let curr = this.$filters.currency
      let price = parseFloat(item.discountedprice ? item.discountedprice : item.price)
      let count = parseFloat(item.count)
      let resourceCount = parseFloat(item.resource_count)
      if (resourceCount) {
        count = count * resourceCount
      }
      return curr(price * count, item.currency)
    }
  },
  mounted () {}
}
</script>

<style scoped>
.reservation-preview-pickups {
  margin-bottom: 10px;
}
.reservation-preview-pickup {
  line-height: 1.5;
}
.well-info {
  background-color: #d9edf7;
}
.well-warning {
  background-color: #fcf8e3;
}
.well-partial {
  background-color: #ffe066;
}
.well {
  margin-bottom: 10px;
}
.reservation-preview-end {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}
.reservation-preview-channel {
  display: block;
  height: 28px;
  width: auto;
  max-width: 180px;
  margin-right: auto;
}
.reservation-preview-channel-text {
  height: auto;
  line-height: 28px;
}
</style>